import Controller from './mainDeath/controller';
import { pageInfo } from './mainDeath/pageInfo';
import Page1 from './mainDeath/page1';
import Page2 from './mainDeath/page2';
import Page3 from './mainDeath/page3';
import Page4 from './mainDeath/page4';
import Page5 from './mainDeath/page5';

new nc.promokit.Preloader({
    'image': [
        '/promo/bns/history/2019/190612_archery/img/page1/btn_close.png',
        '/promo/bns/history/2019/190612_archery/img/page1/btn_play.png',
        '/promo/bns/history/2019/190612_archery/img/page1/btn_scroll.png',
        '/promo/bns/history/2019/190612_archery/img/page1/btn_update.png',
        '/promo/bns/history/2019/190612_archery/img/page1/btn_utils.png',
        '/promo/bns/history/2019/190612_archery/img/page1/char1.png',
        '/promo/bns/history/2019/190612_archery/img/page1/char1_effect1.png',
        '/promo/bns/history/2019/190612_archery/img/page1/char1_effect2.png',
        '/promo/bns/history/2019/190612_archery/img/page1/char2.png',
        '/promo/bns/history/2019/190612_archery/img/page1/char2_.png',
        '/promo/bns/history/2019/190612_archery/img/page1/char2_effect1.png',
        '/promo/bns/history/2019/190612_archery/img/page1/char2_effect2.png',
        '/promo/bns/history/2019/190612_archery/img/page1/sample.jpg',
        '/promo/bns/history/2019/190612_archery/img/page1/title.png',
        '/promo/bns/history/2019/190612_archery/img/page1/txt1.png',
        '/promo/bns/history/2019/190612_archery/img/page1/txt2.png'
    ],
    'video':[],
    'youtbue':[],
    'delay': 1000
});


$(document).on('preloadend', function(){
    $('body').TopBtn();
    $('.toggle-caution').Folding({open: true});

    pageInfo.page1.class = new Page1( pageInfo.page1 );
    pageInfo.page2.class = new Page2( pageInfo.page2 );
    pageInfo.page3.class = new Page3( pageInfo.page3 );
    pageInfo.page4.class = new Page4( pageInfo.page4 );
    pageInfo.page5.class = new Page5( pageInfo.page5 );

    this.ctrl = new Controller( pageInfo );

    $(document).ready(function(){
        $('.lodingBg').remove();
        setTimeout(()=>{
            this.ctrl.init('page1');
            navCtrl();
        }, 500)

        document.querySelector('.section-1 .btn-scroll').addEventListener('click', ()=>{
            this.ctrl._change('page2');
        });
    });
});


const navCtrl = ()=>{
    let nav = document.getElementById('nav');
    document.querySelector('#nav .btn-arrow').addEventListener('click', ()=>{
        nav.getAttribute('class') ? nav.setAttribute('class', '') : nav.setAttribute('class', 'on');
    });
};




// WEBPACK FOOTER //
// ./src/js/index.js